import home from './home'
import details from './details'
import navigation from './navigation'

export default {
  home,
  details,
  navigation
}
